/**
 * @author3173
 * @description 岗位能力管理页面配置
 * @Date 2020/7/17
 */
import React from 'react'
import { component_tool, framework_tool } from '../../../../tool';
import { WizTableForm } from '../../../common'
const organizationConfig = WizTableForm.Config.organization(this, { apiParams: { state: 1 , organizationNodeCategory:["2"]} })
const positionConfig = WizTableForm.Config.position(this, { apiParams: { state: 1 } })

let { WizModal } = component_tool;

//配置项
let componentName = 'abilityCheckCategory'
const columns = [
  {
    name: "id",
    fromItem: {
      type: "hidden"
    }
  },
  {
    title: "能力考核项目",
    name: "name",
    searchItem: {},
    tableItem: {
      width: 270
    },
  },

  {
    title: "岗位",
    name: "positionIds",
    searchItem: {
      diy: WizTableForm,
      ...positionConfig,
    }
  },

  {
    title: "品牌",
    name: "orgName",
    tableItem: {
      width: 130
    },
  },
  {
    title: "品牌",
    name: "orgId",
    searchItem: {
      diy: WizTableForm,
      selectType:"radio",
      ...organizationConfig
    }
  },
  {
    title: "岗位",
    name: "positionsName",
    tableItem: {width: 300},
  },
  {
    title: "状态",
    name: "state",
    dataIndex: "state",
    dict: [
      { code: 1, codeName: '有效' },
      { code: 0, codeName: '无效' }
    ],
    searchItem: {
      type: 'select'
    },
    tableItem: {
      width: 100,
    },
  },
  {
    title: "创建时间",
    name: "createTime",
    tableItem: {
      width: 150,
    },
  },
  {
    title: "最新修改时间",
    name: "updateTime",
    tableItem: {
    },
  },


];

const templateConfig = {
  mainProps: {},
  content: {
    name: "WizTableList",
    params: {
      columns,
      //btnAccessCheck:false,
      searchBarProps: {
        cols: {
          xs: 12,
          md: 12,
          xl: 12
        },
        buttonSort:['add','export'],
        buttons: [
          {
            key: 'add',
            custom: true,
            params: { icon: 'plus', children: '新增', type: 'primary' },
            customOnClick: {
              key: 'jumpPage',
              params: {
                key: 'push',
                pathname: '/train/abilityCheckCategory/categoryDetailAdd'
              }
            }
          },
          {
            key: 'export',
            custom: true,
            params: { icon: 'export', children: '导出', type: 'export'},
            customOnClick: {
              key: 'action',
              params: {
                apiKey: "export",
                apiParams: {}
              },
              formatParams:(rows,record,filters,callback)=>{
                return {...filters}
              }
            }
          }
        ]
      },
      modalFormProps: {},
      dataTableProps: {
        rowKey: "id",
        selectType: "checkbox",
        isScroll: true,
        bordered: false,
        paging: false,
        loading: false
      },
      rowOperateSort:['update','enableOrDisable','management'],
      rowOperateView: [
        {
          key: "update",
          custom: true,
          params: { children: "编辑" },
          customOnClick: {
            key: "jumpPage",
            params: {
              key: "push",
              pathname: "/train/abilityCheckCategory/categoryDetailUpd"
            }
          }
        },
        {
          key: "enableOrDisable",
          custom: true,
          params: { children: "启用"},
          textFormat: {
            recordKey: 'state',
            dirt: { '1': '禁用', '0': '启用', }
          },
          customOnClick: {
            key: "action",
            params: {
              apiKey: "enable",
              apiParams: {}
            },
            formatParams: (rows, record, filters, callback) => {
              const content = `您确定要${
                record['state'] === 0 ? "启用" : "禁用"
                }该能力考核项目吗？`;
              WizModal.confirm({
                title: '注意', content,
                onOk: () => {
                  callback && callback({
                    id: record['id'],
                    ...record,
                    state:record['state'] === 0?1:0
                  })
                },
                onCancel() {
                }
              });
              return null
            }
          }
        },
        {
          key: "management",
          custom: true,
          params: { children: "管理"},
          customOnClick: {
            key: "jumpPage",
            params: {
              key: "push",
              pathname: "/train/abilityCheckCategory/abilityCheckItem"
            }
          }
        }
      ]
    }
  }
};

const apis = {
  list: {
    path: `${componentName}/listByPage`,
    payload: {
      key: `${componentName}@list`,
      apiParams: {}
    }
  },
  enable: {
    path: `${componentName}/updateState`,
    payload: {
      key: `${componentName}@enable`,
      apiParams: {}
    }
  },
  export: {
    path: `${componentName}/listByCondition`,
    payload: {
      key: `${componentName}@export`,
      apiParams: {}
    }
  }
}

let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
};

export { reduxTemplateCofig, templateConfig };
